import Link from "next/link";
import React from "react";

const BannerArea = () => {
  return (
    <div className="tp-cta-2__area mt-10">
      <div
        className="tp-cta-2__bg p-relative fix"
        style={{
          backgroundImage: `url("/assets/img/cta/cta-bg-1.png)`,
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="tp-cta-2__content text-center">
                <span
                  className="tp-cta-2__subtitle  wow tpfadeUp"
                  data-wow-duration=".9s"
                  data-wow-delay=".3s"
                >
                  let's start something for them
                </span>
                <h4
                  className="tp-cta-2__title wow tpfadeUp"
                  data-wow-duration=".9s"
                  data-wow-delay=".5s"
                >
                  No One Has Ever Become <br />
                  Poor From Giving
                </h4>
                <Link
                  href="/make-donation"
                  className="tp-btn theme-2-bg  wow tpfadeUp"
                  data-wow-duration=".9s"
                  data-wow-delay=".7s"
                >
                  Start Donating Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerArea;
